import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faSync } from "@fortawesome/free-solid-svg-icons";
import { ActionsMenu } from "../AccountsUsers/ActionsMenu";
import { formatMoney, formatMXN, formatNumber, isPublic } from "./utils";

const PaymentsTable = ({
    items,
    resumen,
    expanded,
    searched,
    onToggleChannels,
    onPublish,
    onPublishChannel,
    onDownloadXls,
    onView,
    onBilling,
}) => {
    const summaryRows = resumen ? [
        { label: 'Total vendido', value: formatMoney(resumen.total) },
        { label: 'Unidades', value: formatNumber(resumen.units) },
        { label: 'Entradas desde canales', value: formatMoney(resumen.channel_payment) },
        { label: 'Regalías canales', value: formatMoney(resumen.royalties_channel) },
        { label: 'Regalías Ink', value: formatMoney(resumen.royalties_ink) },
        { label: 'Regalías', value: formatMoney(resumen.royalties) },
    ] : [];

    const buildRowActions = (row) => {
        const items = [];
        if (row.total > 0 && row.units > 0 && !isPublic(row.public)) {
            items.push({ label: 'Publicar', onClick: () => onPublish(row) });
        }
        items.push({ label: 'Ver en la app', onClick: () => onView(row) });
        items.push({ label: 'Descargar xls', onClick: () => onDownloadXls(row) });
        items.push({ label: 'Datos de facturación', onClick: () => onBilling(row) });
        return items;
    };

    return (
        <div>
            {resumen && (
                <div className="card shadow-sm border-0 bg-dark mb-4">
                    <div className="card-body p-3">
                        <div className="row g-3">
                            {summaryRows.map((s) => (
                                <div className="col-md-2 col-6 text-center" key={s.label}>
                                    <div className="small text-uppercase text-white-50 fw-bold">{s.label}</div>
                                    <div className="fs-5 fw-bold text-white">{s.value}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            <div className="modern-table-container">
                <table className="modern-table striped-table">
                    <thead>
                        <tr>
                            <th>Cuenta</th>
                            <th>Ink id</th>
                            <th>Tipo</th>
                            <th className="text-end">Total</th>
                            <th className="text-end">Unidades</th>
                            <th className="text-end">Entradas canales</th>
                            <th className="text-end">Regalías canales</th>
                            <th className="text-end">Regalías Ink</th>
                            <th className="text-end">Regalías</th>
                            <th className="text-end">TC</th>
                            <th className="text-end">Regalías MXN</th>
                            <th className="text-center">Publicado</th>
                            <th className="text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.length === 0 && (
                            <tr>
                                <td colSpan="13" className="text-center text-white-50 py-4">
                                    {searched ? 'Sin datos para el periodo seleccionado' : 'Debes realizar una búsqueda para ver los datos'}
                                </td>
                            </tr>
                        )}
                        {items.map((row) => {
                            const isOpen = expanded[row.publisher] !== undefined;
                            const channels = expanded[row.publisher];
                            return (
                                <React.Fragment key={row.id_pub}>
                                    <tr>
                                        <td>
                                            {row.total > 0 ? (
                                                <button
                                                    className="btn btn-link text-white fw-bold p-0 border-0"
                                                    style={{ textDecoration: 'none' }}
                                                    onClick={() => onToggleChannels(row)}
                                                >
                                                    {row.publisher}
                                                    {isOpen
                                                        ? <FontAwesomeIcon icon={faChevronUp} className="ms-2 text-white-50" size="xs" />
                                                        : <FontAwesomeIcon icon={faChevronDown} className="ms-2 text-white-50" size="xs" />}
                                                </button>
                                            ) : (
                                                row.publisher
                                            )}
                                        </td>
                                        <td>{row.ink_id}</td>
                                        <td>{row.client_type}</td>
                                        <td className="text-end">{formatMoney(row.total)}</td>
                                        <td className="text-end">{formatNumber(row.units)}</td>
                                        <td className="text-end">{formatMoney(row.channel_payment)}</td>
                                        <td className="text-end">{formatMoney(row.royalties_channel)}</td>
                                        <td className="text-end">{formatMoney(row.royalties_ink)}</td>
                                        <td className="text-end">{formatMoney(row.royalties)}</td>
                                        <td className="text-end">{formatMoney(row.rate_exchange)}</td>
                                        <td className="text-end">{formatMXN(row.royaltiesMXN)}</td>
                                        <td className="text-center">
                                            {row.total <= 0 || row.units <= 0 ? '-' : isPublic(row.public) ? (
                                                <span className="badge-status success">Si</span>
                                            ) : (
                                                <span className="badge-status status-off">No</span>
                                            )}
                                        </td>
                                        <td className="text-center">
                                            <ActionsMenu items={buildRowActions(row)} title="Acciones de la cuenta" />
                                        </td>
                                    </tr>
                                    {isOpen && (
                                        <tr>
                                            <td colSpan="13" className="p-0">
                                                {channels === 'loading' ? (
                                                    <div className="text-center text-white-50 py-3">
                                                        <FontAwesomeIcon icon={faSync} spin className="me-2" />
                                                        Cargando canales...
                                                    </div>
                                                ) : (
                                                    <div className="table-responsive p-3 bg-black bg-opacity-25">
                                                        <table className="table table-sm table-dark table-borderless align-middle mb-0">
                                                            <thead>
                                                                <tr className="text-white-50 small text-uppercase">
                                                                    <th>Tienda</th>
                                                                    <th className="text-end">Total</th>
                                                                    <th className="text-end">Unidades</th>
                                                                    <th className="text-end">Entradas canales</th>
                                                                    <th className="text-end">Regalías canales</th>
                                                                    <th className="text-end">Regalías Ink</th>
                                                                    <th className="text-end">Regalías</th>
                                                                    <th className="text-end">TC</th>
                                                                    <th className="text-end">Regalías MXN</th>
                                                                    <th className="text-center">Publicado</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {channels.map((ch) => (
                                                                    <tr key={ch.id}>
                                                                        <td>{ch.channel}</td>
                                                                        <td className="text-end">{formatMoney(ch.total)}</td>
                                                                        <td className="text-end">{formatNumber(ch.units)}</td>
                                                                        <td className="text-end">{formatMoney(ch.channel_payment)}</td>
                                                                        <td className="text-end">{formatMoney(ch.royalties_channel)}</td>
                                                                        <td className="text-end">{formatMoney(ch.royalties_ink)}</td>
                                                                        <td className="text-end">{formatMoney(ch.royalties)}</td>
                                                                        <td className="text-end">{formatMoney(ch.rate_exchange)}</td>
                                                                        <td className="text-end">{formatMXN(ch.royaltiesMXN)}</td>
                                                                        <td className="text-center">
                                                                            {ch.total <= 0 || ch.units <= 0 ? (
                                                                                '-'
                                                                            ) : isPublic(ch.active) ? (
                                                                                <span className="badge-status success">Si</span>
                                                                            ) : (
                                                                                <button
                                                                                    className="btn btn-link text-warning fw-bold p-0 border-0"
                                                                                    style={{ textDecoration: 'none' }}
                                                                                    onClick={() => onPublishChannel(row, ch)}
                                                                                >
                                                                                    Publicar
                                                                                </button>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PaymentsTable;